// extracted by mini-css-extract-plugin
export default {"add-link":"A6_vyH5_tgdEmE6GNZI1"};